import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonLink } from '@pattern-library/buttons';
import PropTypes from 'prop-types';
import googleAnalyticsAction from '../../assets/js/analytics.js';
import { clearOtpBeforeUnload } from '../verify-otp/otpBeforeUnload';

const propTypes = {
    elementId: PropTypes.string,
    primaryButtonCaret: PropTypes.bool,
    primaryButtonSubmitEnabled: PropTypes.bool,
    primaryButtonText: PropTypes.string,
    primaryButtonUrl: PropTypes.string,
    primaryButtonAnalytics: PropTypes.string,
    primaryButtonLoadingText: PropTypes.string,
    secondaryButtonCaret: PropTypes.bool,
    secondaryButtonText: PropTypes.string,
    secondaryButtonUrl: PropTypes.string
};

const defaultProps = {
    primaryButtonCaret: true,
    primaryButtonText: 'Next',
    primaryButtonSubmitEnabled: false,
    primaryButtonLoadingText: 'processing',
    secondaryButtonCaret: true,
    secondaryButtonText: 'Previous'
};

class WorkflowNavContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            primaryButtonSubmitEnabled: this.props.primaryButtonSubmitEnabled,
            primaryButtonSubmitClicked: false
        };

        this.handleClick = this.handleClick.bind(this);
    }

    renderComponentAsPortal(component) {
        return typeof window !== 'undefined'
            ? ReactDOM.createPortal(component, document.getElementById(this.props.elementId))
            : null;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.primaryButtonSubmitEnabled !== this.state.primaryButtonSubmitEnabled) {
            this.setState({ primaryButtonSubmitEnabled: nextProps.primaryButtonSubmitEnabled });
        }
    }

    primaryActionAnalytics() {
        if (this.props.primaryButtonAnalytics !== 'undefined') {
            googleAnalyticsAction(this.props.primaryButtonAnalytics);
        }
    }

    handleClick(e) {
        e.preventDefault();
        let isValid =
            HTMLFormElement.prototype.reportValidity !== undefined
                ? e.target.form.reportValidity()
                : e.target.form.checkValidity();
        if (isValid) {
            this.primaryActionAnalytics();
            this.setState(
                { primaryButtonSubmitEnabled: false, primaryButtonSubmitClicked: true },
                this.delayedSubmitForm(e.target.form)
            );
        }
    }

    delayedSubmitForm = form => {
        const submit = () => {
            clearOtpBeforeUnload();
            form.submit();
        };
        if (typeof requestAnimationFrame !== 'undefined') {
            requestAnimationFrame(submit);
        } else {
            setTimeout(submit, 0);
        }
    };

    render() {
        var secondaryButton = this.props.secondaryButtonUrl ? (
            <ButtonLink
                className={
                    this.props.secondaryButtonCaret
                        ? 'asc-btn--secondary asc-btn--icon asc-bg-icon--caret-left asc-btn--left'
                        : 'asc-btn--secondary'
                }
                text={this.props.secondaryButtonText}
                link={this.props.secondaryButtonUrl}
            />
        ) : null;
        var primaryButton = this.props.primaryButtonUrl ? (
            <ButtonLink
                className={
                    this.props.primaryButtonCaret
                        ? 'asc-btn--icon asc-bg-icon--caret-right--white asc-btn--right'
                        : 'asc-btn'
                }
                text={this.props.primaryButtonText}
                link={this.props.primaryButtonUrl}
            />
        ) : (
            <Button
                className={
                    this.props.primaryButtonCaret
                        ? 'asc-btn asc-btn--icon asc-bg-icon--caret-right--white asc-btn--right'
                        : 'asc-btn'
                }
                customAttrs={{
                    'data-workflow-submit': true,
                    'aria-live': 'polite'
                }}
                disabled={!this.state.primaryButtonSubmitEnabled}
                loadingText={this.props.primaryButtonLoadingText}
                showLoading={this.state.primaryButtonSubmitClicked}
                type="submit"
                clickHandler={this.handleClick}
                text={this.props.primaryButtonText}
            />
        );
        var workflowNav = (
            <div className="asc-btn-group asc-btn-group--spread mfa-login-action-container">
                {secondaryButton}
                {primaryButton}
            </div>
        );
        var component = this.props.elementId
            ? this.renderComponentAsPortal(workflowNav)
            : workflowNav;

        return <div>{component}</div>;
    }
}

WorkflowNavContainer.propTypes = propTypes;
WorkflowNavContainer.defaultProps = defaultProps;
export default WorkflowNavContainer;
